
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false
  },
  data() {
    return {
      selectedMode: "",
      numberOfDays: "",
      days: ""
    };
  },
  methods: {
    handleSubmit() {}
  }
};
